import { Button, Checkbox, Dropdown } from "antd";
import { useState } from "react";
import { ReactSVG } from "react-svg";
import "./style.css";

const Filter = ({
  text,
  filters = false,
  filterList = [],
  visibleFilterList = [],
  handleColumnChange,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleOpenChange = (nextOpen) => {
    setDropdownOpen(nextOpen);
  };

  if (filterList.length) {
    return (
      <Dropdown
        placement="bottomCenter"
        trigger={["click"]}
        onOpenChange={handleOpenChange}
        open={dropdownOpen}
        dropdownRender={(menu) => (
          <div
            className={
              "bg-white p-3 w-full border border-gray-100 rounded-lg max-h-96 max-w-80 overflow-y-auto shadow-xl"
            }
          >
            {filterList.map((col) => (
              <div key={col.key} className={"py-2"}>
                <Checkbox
                  checked={visibleFilterList.some((c) => c.key === col.key)}
                  onChange={(e) =>
                    handleColumnChange(e.target.checked, col.key)
                  }
                >
                  {col.title}
                </Checkbox>
              </div>
            ))}
          </div>
        )}
      >
        <Button
          className={
            "gap-2 cursor-pointer p-2 text-sm flex justify-between items-center rounded-lg border-gray-300 border text-medium"
          }
        >
          <ReactSVG src="/assets/icons/filter.svg" />
          {text}
        </Button>
      </Dropdown>
    );
  }

  return (
    <div className={"flex items-center"}>
      <div
        className={
          "flex gap-2 rounded-lg items-center px-2 font-bold py-1.5 border border-gray-300 cursor-pointer text-sm text-gray-700"
        }
      >
        <ReactSVG src="/assets/icons/filter.svg" />
        {text}
      </div>
      {filters && (
        <>
          <div
            className={
              "flex gap-2 rounded-lg items-center px-2 py-1.5 mx-3 bg-gray-100 cursor-pointer text-sm text-gray-500"
            }
          >
            Currency
            <ReactSVG src="/assets/icons/cancel.svg" />
          </div>
          <div
            className={
              "flex gap-2 rounded-lg items-center px-2 py-1.5 bg-gray-100 cursor-pointer text-sm text-gray-500"
            }
          >
            7 July, 2024 - 10 Jul, 2024
            <ReactSVG src="/assets/icons/cancel.svg" />
          </div>

          <p className={"cursor-pointer text-sm ml-4"}>Clear all filters</p>
        </>
      )}
    </div>
  );
};

export default Filter;
